import { render, staticRenderFns } from "./MediaModal.vue?vue&type=template&id=63ba43d4&scoped=true&"
import script from "./MediaModal.ts?vue&type=script&lang=ts&"
export * from "./MediaModal.ts?vue&type=script&lang=ts&"
import style0 from "./MediaModal.scss?vue&type=style&index=0&id=63ba43d4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63ba43d4",
  null
  
)

export default component.exports